import type { FileModel, FileModelFR } from './FileModel';
import { translateFileModel } from './FileModel';

export type TestimonyResponse = {
  nom: string;
  prenom: string;
  temoignageInvestisseur: string;
  dateCreation: Date;
  photo: FileModelFR;
};

export type TestimonyModel = {
  lastName: string;
  firstName: string;
  text: string;
  createdAt: Date;
  photo: FileModel;
};

export type TestimonyRequest = {
  souscriptionId: number;
  temoignage: string;
  miseEnRelationDirigeant: string;
  noteComplexite: number;
  noteRecommanderaitWiseed: number;
};

export const translateTestimoniesResponse = (o: TestimonyResponse): TestimonyModel => {
  return {
    lastName: o.nom,
    firstName: o.prenom,
    text: o.temoignageInvestisseur,
    createdAt: o.dateCreation,
    photo: translateFileModel(o.photo),
  };
};

export const translateTestimoniesArray = (a: TestimonyResponse[]): TestimonyModel[] => {
  return a.map(e => translateTestimoniesResponse(e));
};
